<template>
	<div class="user_center">
		<HeaderComponents></HeaderComponents>
		<div class="content">
			<div class="card">
				<div class="title">基本资料</div>
				<Form class="form" :label-width="80" label-position="left">
					<FormItem label="头像:">
						<Upload :max='1' :img.sync="formItem.head_portrait">
							<!--              <Avatar icon="ios-person" size="large"/>-->
						</Upload>
					</FormItem>
					<FormItem label="昵称:">
						<Input class="input" placeholder="请输入昵称" maxlength="12" v-model="formItem.nickname"></Input>
					</FormItem>
					<FormItem label="姓名:">
						<Input class="input" placeholder="请输入真实姓名" maxlength="6" v-model="formItem.true_name"></Input>
					</FormItem>
					<FormItem label="联系方式:">
						<Input class="input" disabled placeholder="请输入联系方式" maxlength="11"
							v-model="formItem.phone"></Input>
					</FormItem>
					<FormItem label="生日:">
						<Date-picker type="date" placeholder="请选择" style="width: 200px"
							v-model="formItem.birthday"></Date-picker>
					</FormItem>
					<FormItem label="性别:">
						<RadioGroup v-model="formItem.gender">
							<Radio label="1" border style="margin-right: 20px">男</Radio>
							<Radio label="2" border>女</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="所在地区:">
						<Cascader style="width: 300px" :data="cityData" @on-change="cityChange"
							v-model="formItem.proCitDic"></Cascader>
					</FormItem>
					<FormItem label="详细地址:">
						<Input type="textarea" class="input" v-model="formItem.address" maxlength="30"
							placeholder="请输入详细地址"></Input>
					</FormItem>
					<div class="footer">
						<Button type="primary" @click="submit()">更新信息</Button>
					</div>
				</Form>
			</div>
		</div>
	</div>
</template>

<script>
import HeaderComponents from '../../components/header'
import Upload from '../../components/upload'
import areaList from '@/libs/areadata.js'

export default {
  name: 'user_center',
  components: {
    HeaderComponents,
    Upload
  },
  data () {
    return {
      img: '',
      cityData: areaList,
      formItem: {
        gender: '1',
        head_portrait: '',
        nickname: ''
      }

    }
  },
  created () {
    let vm = this
    this.$request('6173cb9f48207', {}).then(res => {
      let user = res.data.data.user
      vm.formItem.gender = res.data.data.user.gender.toString()
      vm.formItem.head_portrait = res.data.data.user.head_img
      vm.formItem.nickname = res.data.data.user.nickname
      vm.formItem.phone = res.data.data.user.phone
      vm.formItem.true_name = res.data.data.user.true_name
      let proCitDic = [user.province_id + '', user.city_id + '', user.district_id + '']
      vm.formItem.proCitDic = proCitDic
      vm.formItem.address = res.data.data.user.address
      vm.formItem.province_name = res.data.data.user.province_name
      vm.formItem.province_id = res.data.data.user.province_id + ''
      vm.formItem.city_name = res.data.data.user.city_name
      vm.formItem.city_id = res.data.data.user.city_id + ''
      vm.formItem.district_name = res.data.data.user.district_name
      vm.formItem.district_id = res.data.data.user.district_id + ''
      vm.formItem.birthday = res.data.data.user.birthday_date
    })
  },
  methods: {
    //
    cityChange (e, a) {
      console.log(e, a, '===============')
      let list = a.map(item => {
        return item.label
      })
      if (a && a[0]) {
        this.formItem.province_name = a[0].label
        this.formItem.province_id = a[0].value
        this.formItem.city_name = a[1].label
        this.formItem.city_id = a[1].value
        this.formItem.district_name = a[2].label
        this.formItem.district_id = a[2].value
      }
    },
    submit () {
      if (!this.formItem.nickname) {
        return this.$message.error('请输入昵称')
      }
      if (!this.formItem.proCitDic) {
        return this.$message.error('请选择所在地区')
      }
      if (!this.formItem.address) {
        return this.$message.error('请输入详细地址')
      }
      console.log(this.formItem, 'this.formItem')
      this.$util.throttle(() => {
        this.$request('6173d05117639', this.formItem).then(res => {
          this.$message.success('修改成功')
          console.log(res.data.data, '修改成功')
          localStorage.setItem('USERINFO', JSON.stringify(res.data.data))
          // this.$store.dispatch('setUserInfo', res.data.data)
          this.$router.push({
            name: 'workbench'
          })
        })
      }, 2000, true)
    }
  }
}
</script>

<style scoped lang="less">
	.user_center {

		.content {
			min-width: 1200px;
			padding: 0 100px;
			background-color: #f7f8fa;
			margin-top: 84px;
		}

		.card {
			background-color: #FFFFFF;
			padding: 20px;
			border-radius: 3px;

			.title {
				font-size: 18px;
				color: #333;
				font-weight: 450;
				position: relative;

				&::after {
					content: '';
					position: absolute;
					bottom: -10px;
					left: 0;
					width: 70px;
					height: 3px;
					background-color: #FB9E2F;
				}
			}

			.form {
				margin-top: 60px;

				.input {
					width: 300px;
				}

				.footer {
					margin-top: 30px;
					margin-bottom: 20px;
				}
			}
		}
	}
</style>
